import { useFluidInterfaceRedirect } from '~/hooks/useTryNewFoam/useFluidInterfaceRedirect';

/**
 * Renders nothing — it exists so the fluid hand-off runs app-wide from `_app`,
 * inside `AppProviders` where the hook's query and feature-flag context live.
 *
 * The visible "Meet the new foam" banner stays in `LoggedLayout`; only the
 * redirect is global, so pages with their own layout are covered too
 * (FOAM-22396).
 */
export const FluidInterfaceRedirect: React.FC = () => {
  useFluidInterfaceRedirect();

  return null;
};
